// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a20c60df","58":"7c04b1fb","162":"0c02b2fe","453":"fcc270cd"}[chunkId] + ".chunk.js";
};